import first from 'lodash/first';
import isEmpty from 'lodash/isEmpty';

import {
  LINK_TYPE_INTERNAL,
  LINK_TYPE_EXTERNAL
} from 'zoomforth_codesbane_viewer/const/link_types.js';

export const shouldHideMainNavigation = (mainMenuItems, submenuItemsForCurrentSubpage, homeSubpageId) => {
  // theoretically this should never happen but let's be safe...
  if (mainMenuItems.length === 0) {
    return true;
  }

  // if we have one main menu item and no submenu items then we should hide the nav
  if (mainMenuItems.length === 1 && first(mainMenuItems).appAction.subpageId === homeSubpageId) {
    if (isEmpty(submenuItemsForCurrentSubpage)) {
      return true;
    }
  }

  return false;
};

// for a page with only one subpage and any anchor links we actually show
// the submenu items in the toplevel navigation.
export const shouldShowSubmenuItemsInToplevel = (mainMenuItems, currentSubmenuItems) =>
  mainMenuItems.length === 1 && !!currentSubmenuItems;

export const getMenuItemDisplayName = (menuItem) => {
  return menuItem.appAction.type === LINK_TYPE_EXTERNAL ?
    'External'
  : menuItem.isSubmenuItem ?
    'Anchor'
  :
    'Internal';
};


export const makeNewMenuItemData = ({ id=null, title='', menuItemType, isPrimaryForSubpage, parentSubpageId })=>
  ({
    id, // temporary menu items never have id
    title,
    isPrimaryForSubpage: isPrimaryForSubpage,
    isSubmenuItem: !isPrimaryForSubpage && !!parentSubpageId,
    appAction: {
      type: menuItemType,
      ...(
        menuItemType === LINK_TYPE_INTERNAL ?
          { subpageId: parentSubpageId }

        : menuItemType === LINK_TYPE_EXTERNAL && !!parentSubpageId ?
          { url: '', target: '_blank', subpageId: parentSubpageId }

        :
          { url: '', target: '_blank' }

      )
    }
  });
